var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.72C0 .77.794 0 1.774 0h20.452C23.206 0 24 .77 24 1.72V22.28c0 .95-.794 1.719-1.774 1.719H1.774C.794 24 0 23.23 0 22.281V1.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.049C20 7.602 16.42 4 12 4s-8 3.602-8 8.049c0 4.024 2.903 7.367 6.742 7.951v-5.615H8.71V12.05h2.032v-1.753c0-2.012 1.193-3.148 3-3.148.903 0 1.806.162 1.806.162v1.98h-1c-1 0-1.322.617-1.322 1.266v1.493h2.226l-.355 2.336h-1.871V20C17.064 19.416 20 16.073 20 12.049Z",
    fill: "var(--bg-color)"
  })));
};
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "b3a6f8b385be522ecaf44f7b0e10ac90.svg";